export const xs: number = 501;
export const sm: number = 576;
export const md: number = 768;
export const lg: number = 992;
export const xl: number = 1200;
